import { appMethod as app } from '@utils/app';
import { getCurrentPageQueryParams, convertLineStyleData } from '@utils/tools';
import { TopNav } from '@common/top-nav/TopNav';
import { Map } from 'src/jisu-component/map/Map';

import OfficialPage from '../OfficialPage';

import './TakeoutOrderDetail.less';

export default class TakeoutOrderDetail extends OfficialPage {
  state = {
    orderData: {},
    orderInfo: {},
    orderStatus: {
      '0': '待付款',
      '1': '待发货',
      '2': '待收货',
      '3': '待评价',
      '4': '退款审核中',
      '5': '退款中',
      '6': '已完成',
      '7': '已关闭',
      '8': '外卖未接单'
    },
    orderStatusText: [
      { name: '待付款剩余时间:', orderName: '请在提交订单20分钟内完成付款' },
      { name: '待商家安排配送', orderName: '预计送达时间：' },
      { name: '配送中', orderName: '预计送达时间：' },
      { name: '订单待评价', orderName: '感谢您的信任，期待下次光临' },
      { name: '退款审核中', orderName: '你已成功发起退款，请耐心等待商家处理' },
      { name: '退款中', orderName: '订单退款中' },
      { name: '订单已完成', orderName: '感谢您的信任，期待下次光临' },
      { name: '已关闭', orderName: '订单已取消' },
      { name: '等待商家接单', orderName: '20分钟商家未接单，订单将自动取消' }
    ],
    transportStatus: {
      0: '待创建',
      1: '待骑手接单',
      2: '骑手已接单', //蜂鸟已分配骑手
      3: '骑手配送中',
      4: '骑手配送已完成',
      5: '已取消',
      7: '已过期',
      8: '指派单',
      9: '妥投异常之物品返回中',
      10: '妥投异常之物品返回完成',
      11: '骑手已到店',
      12: '申请取消配送',
      1000: '订单异常'
    },
    selectAddressId: '',
    goodsAdditionalInfo: {},
    hasAdditionalInfo: false,
    customFields: [],
    orderId: '',
    isFromTemplateMsg: false,
    originalPrice: '',
    useBalance: '',
    freightAdress: {},
    express_fee: '',
    discount_cut_price: '',
    isFromBack: false,
    marker: [
      {
        latitude: 0,
        longitude: 0,
        iconPath: '/images/transport.png',
        width: 75,
        height: 75
      }
    ],
    ismore: false,
    isShowInstruction: false
  }

  constructor(props) {
    super(props);
    document.title = '订单详情';
  }

  componentWillMount(options = getCurrentPageQueryParams()) {
    this.setData({
      orderId: options.detail,
      isFromTemplateMsg: options.from === 'template_msg' ? true : false,
      franchiseeId: options.franchisee || ''
    })
    this.dataInitial()
  }

  onPullDownRefresh = () => {
    this.dataInitial()
  }

  componentDidShow() {
    if (this.data.isFromBack) {
      this.dataInitial()
    } else {
      this.setData({
        isFromBack: true
      })
    }
  }

  mapDetail = e => {
    let dataset = e.currentTarget.dataset,
      marker = [
        {
          latitude: dataset.lat,
          longitude: dataset.lng,
          iconPath: '/images/transport.png',
          width: 75,
          height: 75
        }
      ]
    app.turnToPage(
      '/default/pages/mapDetail/mapDetail?eventParams=' + JSON.stringify(marker)
    )
  }
  canvas = (acceptTime, needTime) => {
    let nowTime = new Date().getTime(),
      winWidth = app.getSystemInfoSync().windowWidth / 750;
      // TODO createCanvasContext
    //   ctx = app.createCanvasContext('canvasArcCir'),
    //   x = 80 * winWidth,
    //   y = 80 * winWidth,
    //   radius = 65 * winWidth,
    //   gradient = ctx.createLinearGradient(0, 0 * winWidth, 0, 160 * winWidth),
    //   angle =
    //     (((nowTime / 1000 - acceptTime) / 60 / needTime) * 2 - 0.5) * Math.PI
    // this.setData({
    //   isOverTime:
    //     (nowTime / 1000 - acceptTime) / 60 / needTime > 1 ? true : false,
    //   deliveryTime: acceptTime
    //     ? this.returnDeliveryTime(acceptTime, needTime)
    //     : ''
    // })
    // gradient.addColorStop('0', '#FF5900')
    // gradient.addColorStop('0.5', '#FFA156')
    // gradient.addColorStop('1', '#FF8838')
    // if (acceptTime) {
    //   ctx.draw()
    //   ctx.setTextAlign('center')
    //   ctx.setTextBaseline('bottom')
    //   ctx.setFontSize(36 * winWidth)
    //   ctx.fillText(
    //     this.returnDeliveryTime(acceptTime, needTime),
    //     x,
    //     90 * winWidth
    //   )
    //   ctx.setTextBaseline('top')
    //   ctx.setFontSize(21 * winWidth)
    //   ctx.setFillStyle('#a3a3a3')
    //   ctx.fillText('预计送达', x, 90 * winWidth)
    // } else {
    //   ctx.save()
    //   ctx.beginPath()
    //   ctx.arc(x, y, 55 * winWidth, 0, 2 * Math.PI)
    //   ctx.clip()
    //   ctx.drawImage(
    //     'http://img.weiye.me/tmp_file/df5be6203a516ea94b792b357551fbe81.png',
    //     15 * winWidth,
    //     15 * winWidth,
    //     130 * winWidth,
    //     130 * winWidth
    //   )
    //   ctx.restore()
    // }
    // ctx.setLineWidth(12 * winWidth)
    // ctx.setStrokeStyle(gradient)
    // ctx.setLineCap('round')
    // ctx.beginPath()
    // ctx.arc(x, y, radius, 1.5 * Math.PI, angle, true)
    // ctx.stroke()
    // ctx.draw()
  }
  getGoldenData = id => {
    let that = this
    app.sendRequest({
      url: '/index.php?r=appLotteryActivity/getTimeAfterConsume',
      method: 'post',
      data: {
        order_id: id,
        sub_app_id: that.data.franchiseeId
      },
      success: function (data) {
        if (data.integral) {
          //支付获取积分
          that.setData({
            rewardPointObj: {
              showModal: true,
              count: data.integral,
              callback: ''
            }
          })
        }
      }
    })
  }
  makePhoneCall = e => {
    var phone = e.currentTarget.dataset.phone
    app.makePhoneCall(phone)
  }
  dataInitial = () => {
    this.getTakeOutInfo()
    this.getOrderDetail(this.data.orderId)
    this.initialAddressId()
  }
  turnToOrderTracking = () => {
    app.turnToPage(
      '/orderMeal/pages/orderTracking/orderTracking?orderId=' +
      this.data.orderId
    )
  }
  getOrderStatus = orderId => {
    let that = this
    app.sendRequest({
      url: '/index.php?r=AppTransport/queryTransporterInfo',
      data: {
        order_id: orderId
      },
      success: function (res) {
        let newdata = {}
        newdata['marker[0].latitude'] = res.data.transporter_latitude
        newdata['marker[0].longitude'] = res.data.transporter_longitude
        newdata['transporterInfo'] = res.data
        that.setData(newdata)
      }
    })
  }
  getOrderDetail = orderId => {
    var that = this
    app.sendRequest({
      url: '/index.php?r=AppShop/getOrder',
      data: {
        order_id: orderId,
        sub_shop_app_id: this.data.franchiseeId,
        is_get_indemnity_order: 1,
        is_buyer: 1,
        not_get_takeout: 1
      },
      success: function (res) {
        var data = res.data[0],
          form_data = data.form_data,
          hasAdditionalInfo = false,
          additional_info_goods = [],
          additional_goodsid_arr = [],
          address_id = ''
        if (form_data.status != 0) {
          that.getGoldenData(orderId)
          if (
            form_data.status == 2 &&
            form_data.take_out_info.deliver_type != 0 &&
            form_data.take_out_info.deliver_type != '' &&
            (form_data.take_out_transport_order.status == 2 ||
              form_data.take_out_transport_order.status == 3 ||
              form_data.take_out_transport_order.status == 11)
          ) {
            that.getOrderStatus(that.data.orderId)
          }
        }
        for (var i = 0; i < form_data.goods_info.length; i++) {
          var deliveryId = form_data.goods_info[i].delivery_id,
            goodsId = form_data.goods_info[i].goods_id
          if (
            deliveryId &&
            deliveryId != '0' &&
            additional_goodsid_arr.indexOf(goodsId) == -1
          ) {
            additional_info_goods.push(form_data.goods_info[i])
            additional_goodsid_arr.push(goodsId)
            if (
              form_data.additional_info &&
              form_data.additional_info[goodsId]
            ) {
              for (
                let i = 0;
                i < form_data.additional_info[goodsId].length;
                i++
              ) {
                if (form_data.additional_info[goodsId][i].value) {
                  hasAdditionalInfo = true
                }
              }
            }
          }
        }
        let estimateTime
        if (data.form_data.take_out_info.accept_time) {
          estimateTime = that.returnDeliveryTime(
            +data.form_data.take_out_info.accept_time,
            +data.form_data.take_out_info.deliver_time
          )
        }
        var sytime
        if (data.form_data.add_time) {
          let nowTime = new Date().getTime()
          let addTime = data.form_data.add_time.replace(/\-/g, '/')
          let time = 20 * 60000 - (nowTime - new Date(addTime + '').getTime())
          if (time <= 0) {
            sytime = '0:00'
          } else {
            sytime = that.returHM(time)
          }
        }
        that.setData({
          orderData: data,
          orderInfo: form_data,
          estimateTime: estimateTime || '',
          hasAdditionalInfo: hasAdditionalInfo,
          discount_cut_price: form_data.discount_cut_price,
          useBalance: form_data['use_balance'],
          express_fee: res.data[0]['express_fee'],
          sytime: sytime
        })
        app.setPreviewGoodsInfo(additional_info_goods)
        that.canvas(
          data.form_data.take_out_info.accept_time,
          +data.form_data.take_out_info.deliver_time
        )
        if (form_data.is_self_delivery == 1) {
          that.getFreigtAdress()
        } else {
          address_id = form_data.address_info.address_id
          that.setData({
            selectAddressId: address_id
          })
        }
        app.setGoodsAdditionalInfo(form_data.additional_info || {})
      }
    })
  }
  returnDeliveryTime = (accept_time, deliver_time) => {
    let time = accept_time * 1000 + deliver_time * 60000,
      HM = (
        new Date(time).toISOString().split('T')[0] +
        ' ' +
        new Date(time).toTimeString().split(' ')[0]
      ).split(' ')[1]
    HM = HM.split(':')[0] + ':' + HM.split(':')[1]
    return HM
  }
  returHM = time => {
    let minutes = parseInt((time % (1000 * 60 * 60)) / (1000 * 60))
    let seconds = parseInt((time % (1000 * 60)) / 1000)
    minutes < 10 ? (minutes = '0' + minutes) : (minutes = minutes)
    seconds < 10 ? (seconds = '0' + seconds) : (seconds = seconds)
    let HM = minutes + ':' + seconds
    return HM
  }
  makeComment = e => {
    var orderId = this.data.orderId,
      franchiseeId = this.data.franchiseeId,
      queryStr =
        franchiseeId === app.getAppId() ? '' : '&franchisee=' + franchiseeId
    app.turnToPage(
      '/orderMeal/pages/takeoutMakeComment/takeoutMakeComment?detail=' +
      orderId +
      queryStr
    )
  }
  orderDelete = e => {
    var orderId = this.data.orderId,
      that = this,
      franchiseeId = this.data.franchiseeId
    app.showModal({
      content: '订单删除后不可找回，确认删除？',
      showCancel: true,
      cancelText: '取消',
      confirmText: '确定',
      confirm: function () {
        app.sendRequest({
          url: '/index.php?r=AppShop/HideOrder',
          data: {
            order_id: orderId,
            sub_shop_app_id: franchiseeId
          },
          success: function (res) {
            app.turnBack()
          }
        })
      }
    })
  }
  cancelOrder = e => {
    var orderId = this.data.orderInfo.order_id,
      that = this
    app.showModal({
      content: '你将要取消一笔付款订单，确认取消？',
      showCancel: true,
      confirmText: '是',
      cancelText: '否',
      confirm: function () {
        app.sendRequest({
          url: '/index.php?r=AppShop/cancelOrder',
          data: {
            order_id: orderId,
            sub_shop_app_id: that.data.franchiseeId
          },
          success: function (res) {
            var data = {}
            data['orderInfo.status'] = 7
            that.setData(data)
          }
        })
      }
    })
  }
  payOrder = e => {
    var address_info = this.data.orderInfo.address_info,
      that = this,
      orderId
    if (!address_info && this.data.orderInfo.goods_type != 3) {
      app.showModal({
        content: '请选择邮寄地址'
      })
      return
    }
    orderId = this.data.orderInfo.order_id
    if (this.data.orderInfo.total_price == 0) {
      app.sendRequest({
        url: '/index.php?r=AppShop/paygoods',
        data: {
          order_id: orderId,
          total_price: 0
        },
        success: function (res) {
          setTimeout(function () {
            app.showToast({
              title: '支付成功',
              icon: 'success'
            })
          })
          setTimeout(function () {
            that.getOrderDetail(that.data.orderInfo.order_id)
          }, 1000)
        }
      })
      return
    }
    app.sendRequest({
      url: '/index.php?r=AppShop/GetWxWebappPaymentCode',
      data: {
        order_id: orderId,
        sub_shop_app_id: that.data.franchiseeId
      },
      success: function (res) {
        var param = res.data,
          orderId = that.data.orderInfo.order_id
        param.orderId = orderId
        param.goodsType = that.data.orderInfo.goods_type
        param.success = function () {
          setTimeout(function () {
            that.getOrderDetail(orderId)
          }, 1500)
        }
        app.wxPay(param)
      }
    })
  }
  applyDrawback = () => {
    var orderId = this.data.orderInfo.order_id,
      that = this
    app.showModal({
      content: '确定申请退款？',
      showCancel: true,
      confirmText: '确定',
      cancelText: '取消',
      confirm: function () {
        app.sendRequest({
          url: '/index.php?r=AppShop/applyRefund',
          data: {
            order_id: orderId,
            sub_shop_app_id: that.data.franchiseeId
          },
          success: function (res) {
            var data = {}
            data['orderInfo.status'] = 4
            that.setData(data)
          },
          successShowModalConfirm: function () {
            that.dataInitial()
          }
        })
      }
    })
  }
  toCancelOrder = e => {
    app.turnToPage(
      '/orderMeal/pages/cancelOrder/cancelOrder?orderId=' +
      this.data.orderId +
      '&deliverType=' +
      this.data.orderInfo.take_out_info.deliver_type +
      '&franchisee=' +
      this.data.franchiseeId
    )
  }
  receiveDrawback = () => {
    var orderId = this.data.orderInfo.order_id,
      that = this
    app.showModal({
      content: '确定已收到退款？',
      showCancel: true,
      confirmText: '确定',
      cancelText: '取消',
      confirm: function () {
        app.sendRequest({
          url: '/index.php?r=AppShop/comfirmRefund',
          data: {
            order_id: orderId,
            sub_shop_app_id: that.data.franchiseeId
          },
          success: function (res) {
            var data = {}
            data['orderInfo.status'] = 7
            that.setData(data)
          }
        })
      }
    })
  }
  checkLogistics = () => {
    var orderId = this.data.orderInfo.order_id
    app.turnToPage(
      '/eCommerce/pages/logisticsPage/logisticsPage?detail=' + orderId
    )
  }
  sureReceipt = () => {
    var orderId = this.data.orderInfo.order_id,
      that = this
    app.showModal({
      content: '确定已收到货物？',
      showCancel: true,
      confirmText: '确定',
      cancelText: '取消',
      confirm: function () {
        app.sendRequest({
          url: '/index.php?r=AppShop/comfirmOrder',
          data: {
            order_id: orderId,
            sub_shop_app_id: that.data.franchiseeId
          },
          success: function (res) {
            var data = {}
            data['orderInfo.status'] = 3
            that.setData(data)
          }
        })
      }
    })
  }
  showAddressList = () => {
    var addressId = this.data.selectAddressId,
      orderId = this.data.orderInfo.order_id,
      franchiseeId = this.data.franchiseeId
    app.turnToPage(
      '/eCommerce/pages/myAddress/myAddress?id=' +
      addressId +
      '&oid=' +
      orderId +
      '&sub_shop_id=' +
      franchiseeId,
      true
    )
  }
  goToHomepage = () => {
    var router = app.getHomepageRouter()
    app.turnToPage('/pages/' + router + '/' + router, true)
  }
  verificationCode = () => {
    app.turnToPage(
      '/eCommerce/pages/verificationCodePage/verificationCodePage?detail=' +
      this.data.orderInfo.order_id +
      '&sub_shop_app_id=' +
      this.data.franchiseeId
    )
  }
  getFreigtAdress = () => {
    var that = this
    app.sendRequest({
      url: '/index.php?r=AppShop/getAppShopLocationInfo',
      data: {
        app_id: app.getAppId()
      },
      success: function (res) {
        that.setData({
          freightAdress: res.data
        })
      }
    })
  }
  freightGoMap = () => {
    var _this = this,
      infor =
        _this.data.freightAdress.region_string +
        _this.data.freightAdress.shop_location
    infor = infor.replace(/\s+/g, '')
    app.sendRequest({
      url: '/index.php?r=Map/GetLatAndLngByAreaInfo',
      data: {
        location_info: infor
      },
      success: function (res) {
        if (res.result) {
          app.openLocation({
            latitude: res.result.location.lat,
            longitude: res.result.location.lng
          })
        }
      }
    })
  }
  initialAddressId = () => {
    var that = this
    app.sendRequest({
      url: '/index.php?r=AppShop/addressList',
      data: {
        app_id: app.getAppId()
      },
      success: function (res) {
        if (res.data.length) {
          that.setData({
            selectAddressId: res.data[0].id
          })
        }
      }
    })
  }
  freightPlayPhone = () => {
    var that = this
    app.makePhoneCall(that.data.freightAdress.shop_contact)
  }
  seeAdditionalInfo = () => {
    app.turnToPage(
      '/eCommerce/pages/goodsAdditionalInfo/goodsAdditionalInfo?from=goodsOrderDetail'
    )
  }
  callTakeout = event => {
    let phone = event.currentTarget.dataset.phone
    app.makePhoneCall(phone)
  }
  copyOrder = e => {
    let that = this
    let dataset = e.currentTarget.dataset
    app.setClipboardData({
      data: dataset.order,
      success: function () {
        app.showToast({
          title: '复制成功',
          icon: 'success'
        })
      }
    })
  }
  selectMore = e => {
    let that = this
    let dataset = e.currentTarget.dataset
    this.setData({ ismore: !dataset.ismore })
  }
  hideMore = e => {
    this.setData({ ismore: false })
  }
  toFeedback = e => {
    app.turnToPage(
      '/orderMeal/pages/takeoutFeedback/takeoutFeedback?orderId=' +
      this.data.orderId +
      '&deliverType=' +
      this.data.orderInfo.take_out_info.deliver_type
    )
  }
  toFeedbackDetail = e => {
    app.turnToPage(
      '/orderMeal/pages/indemnityOrder/indemnityOrder?orderId=' +
      this.data.orderId +
      '&deliverType=' +
      this.data.orderInfo.take_out_info.deliver_type
    )
  }
  cancelRefund = e => {
    var that = this
    app.showModal({
      content: '是否撤销取消订单申请？',
      showCancel: true,
      cancelText: '取消',
      confirmText: '确定',
      confirm: function () {
        app.sendRequest({
          url: '/index.php?r=AppShop/cancelRefund',
          data: {
            app_id: app.getAppId(),
            order_id: that.data.orderInfo.order_id
          },
          success: function (res) {
            that.getOrderDetail(that.data.orderId)
          }
        })
      }
    })
  }
  getTakeOutInfo = () => {
    var that = this
    app.sendRequest({
      url: '/index.php?r=AppShop/getTakeOutInfo',
      success: function (res) {
        that.setData({
          takeoutInfo: res.data || ''
        })
      }
    })
  }
  cancelReason = () => {
    this.setData({
      isShowInstruction: true
    })
  }
  hideInstruction = () => {
    this.setData({
      isShowInstruction: false
    })
  }

  render() {
    const {
      rewardPointObj,
      shareGiftsObj,
      collectGiftsObj,
      collectGetObj,
      showGetUserInfo,
      isFromTemplateMsg,
      orderInfo,
      transporterInfo,
      sytime,
      orderStatusText,
      estimateTime,
      deliveryTime,
      orderData,
      ismore,
      marker,
      franchiseeId,
      takeoutInfo,
      discount_cut_price,
      useBalance,
      hasAdditionalInfo,
      isShowInstruction
    } = this.state

    return (
      <div className="official-page takeout-order-detail">
        <TopNav title="订单详情"/>
        <React.Fragment>
          <div onClick={this.hideMore}>
            {isFromTemplateMsg && (
              <div
                className="order-detail-section orderDetail-goto-homepage"
                onClick={this.goToHomepage}
                style={convertLineStyleData('margin-bottom:0;')}
              >
                <div className="ico-moon icon-rightarrow"></div>返回首页
              </div>
            )}
            <div className="takeoutInfo">
              <div
                style={convertLineStyleData(
                  orderInfo.status == 2 &&
                    transporterInfo &&
                    transporterInfo.transport_order_data.status >= 2
                    ? 'float:left;margin-left:30rpx;text-align:left;'
                    : ''
                )}
              >
                <div onClick={this.turnToOrderTracking}>
                  {((orderData.form_data && orderData.form_data.take_out_info.deliver_type == 0) || (orderData.form_data && orderData.form_data.take_out_info.deliver_type == '')) 
                    ? orderStatusText[orderInfo.status].name 
                    : (orderInfo.status == 2 
                      ? transportStatus[orderInfo.take_out_transport_order.status]  : (orderStatusText[orderInfo.status] && orderStatusText[orderInfo.status].name))}
                  {orderInfo.status == 0 && (
                    <span style={convertLineStyleData('color: #FF7100;')}>{sytime}</span>
                  )}
                  {/*  <text wx:if="{{orderInfo.status == 2}}" style={convertLineStyleData('color: #FF7100;')} >{{deliveryTime}}</text>  */}
                  <div
                    className="ico-moon icon-rightarrow"
                    style={convertLineStyleData('font-size:24rpx;')}
                  ></div>
                </div>
                <div style={convertLineStyleData('font-size: 26rpx;color:#999;margin-top:16rpx;font-weight: normal;')}>
                  {orderStatusText[orderInfo.status] && orderStatusText[orderInfo.status].orderName}
                  {orderInfo.status == 1 && (
                    <span style={convertLineStyleData('color: #FF7100;')}>
                      {orderInfo.take_out_info.takeout_appointment_arrive_time ||
                        estimateTime}
                    </span>
                  )}
                  {orderInfo.status == 2 && (
                    <span style={convertLineStyleData('color: #FF7100;')}>{deliveryTime}</span>
                  )}
                </div>
              </div>
              <div
                className="status-btn"
                style={convertLineStyleData(
                  orderInfo.status == 4 ||
                    (orderInfo.take_out_transport_order && orderInfo.take_out_transport_order.status == 1) ||
                    (orderInfo.status == 1 &&
                      orderInfo.take_out_info.transport_shop_id)
                    ? 'height:auto'
                    : 'height:70rpx;'
                )}
              >
                <div className="txt-c">
                  {orderInfo.status == 3 && (
                    <React.Fragment>
                      <span
                        className="btn btn-orange orderDetail-pay-directly"
                        onClick={this.makeComment}
                        data-id={orderData.form_data.order_id}
                      >
                        立即评价
                      </span>
                    </React.Fragment>
                  )}
                  {orderInfo.status == 0 && (
                    <React.Fragment>
                      <span
                        className="btn btn-orange orderDetail-pay-directly"
                        onClick={this.payOrder}
                      >
                        立即支付
                      </span>
                      <span
                        className="btn"
                        onClick={this.cancelOrder}
                        style={convertLineStyleData('color:#999999')}
                      >
                        取消支付
                      </span>
                    </React.Fragment>
                  )}
                  {orderInfo.status == 1 && (
                    <React.Fragment>
                      {!orderInfo.take_out_info.transport_shop_id && (
                        <span
                          className="btn"
                          onClick={this.toCancelOrder}
                          style={convertLineStyleData('color:#999999')}
                        >
                          取消订单
                        </span>
                      )}
                      {orderInfo.refund_info && orderInfo.refund_info.refuse_msg && (
                        <span
                          className="btn"
                          style={convertLineStyleData('color:#999999')}
                          onClick={this.cancelReason}
                        >
                          取消原因
                        </span>
                      )}
                    </React.Fragment>
                  )}
                  {orderInfo.status == 2 && (
                    <React.Fragment>
                      {(orderInfo.take_out_transport_order.status == 4 ||
                        (orderInfo.take_out_transport_order.status == 3 &&
                          orderInfo.take_out_info.deliver_type == 3) ||
                        orderInfo.take_out_info.deliver_type == 0) && (
                          <span
                            className="btn btn-orange"
                            onClick={this.sureReceipt}
                            style={convertLineStyleData(
                              (orderInfo.status == 2 &&
                                transporterInfo &&
                                transporterInfo.transport_order_data.status >= 2
                                ? 'float:right;'
                                : 'margin-right:20rpx;')
                            )}
                          >
                            确认收货
                        </span>
                        )}
                      {orderInfo.take_out_transport_order.status == 5 && (
                        <span className="btn" onClick={this.orderDelete}>
                          刪除订单
                        </span>
                      )}
                    </React.Fragment>
                  )}
                  {/*  <block wx:if="{{ orderInfo.status == 2 && orderInfo.take_out_transport_order.status == 1000}}">
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                <text class="btn" bindtap="orderDelete">刪除订单</text>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              </block>  */}
                  {orderInfo.status == 3 && (
                    <React.Fragment>
                      {/*  <text class="btn btn-orange" bindtap="makeComment">去评价</text>  */}
                      <div className="selectMore">
                        <div onClick={this.selectMore} data-ismore={ismore}>
                          更多
                          <label
                            className="ico-moon icon-downarrow"
                            style={convertLineStyleData('color:#D2D2D2;')}
                          ></label>
                        </div>
                        {ismore && (
                          <div onClick={this.orderDelete}>删除订单</div>
                        )}
                        {ismore && !orderInfo.take_out_indemnity_order && (
                          <div
                            onClick={this.toFeedback}
                            data-order={orderInfo.order_id}
                          >
                            问题反馈
                          </div>
                        )}
                        {ismore && orderInfo.take_out_indemnity_order && (
                          <div
                            onClick={this.toFeedbackDetail}
                            data-order={orderInfo.order_id}
                          >
                            反馈详情
                          </div>
                        )}
                      </div>
                    </React.Fragment>
                  )}
                  {orderInfo.status == 4 && (
                    <React.Fragment>
                      <span
                        className="btn"
                        onClick={this.cancelRefund}
                        style={convertLineStyleData('margin-bottom:16rpx;')}
                      >
                        撤销申请
                      </span>
                      <div style={convertLineStyleData('height:1px;margin:10rpx 28rpx 20rpx;background-color:#F3F3F3;')}></div>
                      <div className="refund">
                        <span style={convertLineStyleData('margin-bottom:24rpx;')}>
                          商家同意或者超时超时处理，系统将退款给您
                        </span>
                        <span style={convertLineStyleData('margin-right:0;')}>
                          如果商家拒绝，您可以修改退款申请后再次发起，商家会重新处理
                        </span>
                      </div>
                    </React.Fragment>
                  )}
                  {orderInfo.status == 5 && (
                    <React.Fragment>
                      <span className="btn" onClick={this.receiveDrawback}>
                        收到退款
                      </span>
                    </React.Fragment>
                  )}
                  {orderInfo.status == 6 && (
                    <React.Fragment>
                      <span className="btn" onClick={this.orderDelete}>
                        刪除订单
                      </span>
                      {!orderInfo.take_out_indemnity_order && (
                        <span
                          className="btn"
                          onClick={this.toFeedback}
                          data-order={orderInfo.order_id}
                        >
                          问题反馈
                        </span>
                      )}
                      {orderInfo.take_out_indemnity_order && (
                        <span
                          className="btn"
                          onClick={this.toFeedbackDetail}
                          data-order={orderInfo.order_id}
                        >
                          反馈详情
                        </span>
                      )}
                    </React.Fragment>
                  )}
                  {orderInfo.status == 7 && (
                    <React.Fragment>
                      <span className="btn" onClick={this.orderDelete}>
                        刪除订单
                      </span>
                    </React.Fragment>
                  )}
                  {orderInfo.status == 8 && (
                    <React.Fragment>
                      <span
                        className="btn"
                        onClick={this.toCancelOrder}
                        style={convertLineStyleData('color:#999999')}
                      >
                        取消订单
                      </span>
                      {orderInfo.refund_info && orderInfo.refund_info.refuse_msg && (
                        <span
                          className="btn"
                          style={convertLineStyleData('color:#999999')}
                          onClick={this.cancelReason}
                        >
                          取消原因
                        </span>
                      )}
                    </React.Fragment>
                  )}
                </div>
              </div>
            </div>
            {orderInfo.status == 2 &&
              transporterInfo &&
              transporterInfo.transport_order_data.status >= 2 && (
                <div
                  className="order-detail-section"
                  style={convertLineStyleData('margin:20rpx;padding:26rpx 30rpx;margin-top:0;padding-top:0;')}
                >
                  <Map
                    onClick={this.mapDetail}
                    data-lat={transporterInfo.transporter_latitude}
                    data-lng={transporterInfo.transporter_longitude}
                    style={convertLineStyleData('margin:0px auto 20rpx;width:100%;')}
                    longitude={transporterInfo.transporter_longitude}
                    latitude={transporterInfo.transporter_latitude}
                    scale="18"
                    markers={marker}
                    showLocation={true}
                  ></Map>
                </div>
              )}
            <div
              className="order-detail-section"
              style={convertLineStyleData('margin-bottom: 0; padding:0 30rpx; border-bottom: none;margin:20rpx;')}
            >
              <div style={convertLineStyleData('padding:26rpx 0rpx;background:#fff;font-weight: 500;border-bottom:1px solid #F3F3F3;')}>
                <img
                  className="shopImage"
                  src={
                    franchiseeId
                      ? orderInfo.sub_shop_info.logo
                      : takeoutInfo && takeoutInfo.cover
                  }
                />
                <span>
                  {franchiseeId
                    ? orderInfo.sub_shop_info.name
                    : takeoutInfo && takeoutInfo.title}
                </span>
                {franchiseeId ? (
                  <React.Fragment>
                    {orderInfo.sub_shop_info.phone && (
                      <div
                        onClick={this.callTakeout}
                        data-phone={orderInfo.sub_shop_info.phone}
                        className="info-takeout-phone"
                      >
                        <label
                          className="ico-moon icon-fn-phone"
                          style={convertLineStyleData('font-size:40rpx;color:#d2d2d2;')}
                        ></label>
                      </div>
                    )}
                  </React.Fragment>
                ) : (
                    <React.Fragment>
                      <div
                        onClick={this.callTakeout}
                        data-phone={takeoutInfo && takeoutInfo.phone}
                        className="info-takeout-phone"
                      >
                        <label
                          className="ico-moon icon-fn-phone"
                          style={convertLineStyleData('font-size:40rpx;color:#d2d2d2;')}
                        ></label>
                      </div>
                    </React.Fragment>
                  )}
              </div>
              {orderInfo.goods_info && orderInfo.goods_info.map((goods, goodsIndex) => {
                return (
                  <div className="goods-list-item" key={goodsIndex}>
                    <div className="inner-content">
                      <img className="waimai-img" src={goods.cover} />
                      <div style={convertLineStyleData('width: initial;')} className="waimai-title">
                        <div className="waimai-title-text">
                          {goods.goods_name}
                        </div>
                        <div style={convertLineStyleData('word-break: break-all;max-width: 300rpx;overflow: hidden;height: 28rpx;line-height: 28rpx;text-overflow: ellipsis;white-space: nowrap;')}>
                          {goods.model_value && (
                            <span className="goods-model">
                              {'(' + goods.model_value + ')'}
                            </span>
                          )}
                        </div>
                        <div>
                          <span style={convertLineStyleData('color: #999;font-size: 28rpx;')}>
                            {'x ' + goods.num}
                          </span>
                        </div>
                      </div>
                      <div className="totle-price">
                        <span style={convertLineStyleData('font-size:20rpx;')}>¥</span>
                        {goods.price * goods.num}
                      </div>
                    </div>
                  </div>
                )
              })}
              {orderInfo.take_out_info && orderInfo.take_out_info.box_fee && (
                <div className="order-detail-section" style={convertLineStyleData('margin-bottom: 0;')}>
                  <span className="classname orange">包装</span>
                  <span style={convertLineStyleData('font-size:24rpx;color:#333333;')}>餐盒费</span>
                  <span className="pull-right" style={convertLineStyleData('font-size:26rpx;')}>
                    <span style={convertLineStyleData('font-size:20rpx;')}>¥</span>
                    {orderInfo.take_out_info.box_fee}
                  </span>
                </div>
              )}
              <div className="order-detail-section" style={convertLineStyleData('margin-bottom: 0;')}>
                <span className="classname orange">配送费</span>
                {orderInfo.status > 1 && orderInfo.status != 8 && (
                  <span style={convertLineStyleData('font-size:24rpx;color:#333333;')}>
                    {orderInfo.take_out_info.deliver_type == 0
                      ? '商家配送'
                      : orderInfo.take_out_info.deliver_type == 3
                        ? '达达配送'
                        : '蜂鸟配送'}
                  </span>
                )}
                <span className="pull-right" style={convertLineStyleData('font-size:26rpx;')}>
                  <span style={convertLineStyleData('font-size:20rpx;')}>¥</span>
                  {orderInfo.take_out_info && orderInfo.take_out_info.deliver_fee}
                </span>
              </div>
              {discount_cut_price > 0 && (
                <div className="order-detail-section" style={convertLineStyleData('margin-bottom: 0;')}>
                  <span className="classname pink">优惠</span>
                  <span style={convertLineStyleData('font-size:24rpx;color:#333333;')}>
                    {orderInfo.selected_benefit.name}
                  </span>
                  <span
                    className="pull-right"
                    style={convertLineStyleData('font-size:26rpx;color:#FF7100;')}
                  >
                    <span style={convertLineStyleData('font-size:20rpx;')}>- ¥</span>
                    {discount_cut_price}
                  </span>
                </div>
              )}
              {orderInfo.extra_discount_cut_price > 0 && (
                <div className="order-detail-section" style={convertLineStyleData('margin-bottom: 0;')}>
                  <span className="classname pink">联盟优惠</span>
                  <span style={convertLineStyleData('font-size:24rpx;color:#333333;')}>
                    {orderInfo.extra_selected_benefit_info.name}
                  </span>
                  <span
                    className="pull-right"
                    style={convertLineStyleData('font-size:26rpx;color:#FF7100;')}
                  >
                    <span style={convertLineStyleData('font-size:20rpx;')}>- ¥</span>
                    {orderInfo.extra_discount_cut_price}
                  </span>
                </div>
              )}
              <div
                className="order-detail-section"
                style={convertLineStyleData('margin-bottom: 0;border-bottom:1px solid #F3F3F3;')}
              >
                <span className="classname pink">储值</span>
                <span style={convertLineStyleData('font-size:24rpx;color:#333333;')}>储值优惠</span>
                <span
                  className="pull-right"
                  style={convertLineStyleData('font-size:26rpx;color:#FF7100;')}
                >
                  <span style={convertLineStyleData('font-size:20rpx;')}>- ¥</span>
                  {useBalance}
                </span>
              </div>
              {orderInfo.coupon_fee && (
                <div
                  className="order-detail-section"
                  style={convertLineStyleData('margin-bottom: 0;margin-top:20rpx;border-bottom:1px solid #F3F3F3;')}
                >
                  <span>社交立减金</span>
                  <span
                    className="pull-right"
                    style={convertLineStyleData('font-size:26rpx;color:#FF7100;')}
                  >
                    <span style={convertLineStyleData('font-size:20rpx;')}>- ¥</span>
                    {orderInfo.coupon_fee}
                  </span>
                </div>
              )}
              <div
                className="order-detail-section"
                style={convertLineStyleData('margin-top:28rpx;border-bottom:none;')}
              >
                实付
                <span className="pull-right" style={convertLineStyleData('font-size:26rpx;')}>
                  <span style={convertLineStyleData('font-size:26rpx;')}>¥</span>
                  <span style={convertLineStyleData('font-size:34rpx;')}>{orderInfo.total_price}</span>
                </span>
              </div>
            </div>
            <div
              className="order-detail-section"
              style={convertLineStyleData('margin-bottom: 0; padding:0 30rpx; border-bottom: none;margin:20rpx;')}
            >
              <div className="deliver_title">配送信息</div>
              {orderInfo.take_out_info && orderInfo.take_out_info.takeout_appointment_arrive_time && (
                <div className="order-detail-section" style={convertLineStyleData('margin-bottom: 0;')}>
                  <span style={convertLineStyleData('color:#666666;')}>送达时间</span>
                  <div
                    className="pull-right"
                    style={convertLineStyleData('font-size: 26rpx;color: #666;')}
                  >
                    <span>
                      {orderInfo.take_out_info.takeout_appointment_arrive_time ||
                        estimateTime}
                    </span>
                  </div>
                </div>
              )}
              {orderInfo.status > 1 && orderInfo.status != 8 && (
                <div className="order-detail-section" style={convertLineStyleData('margin-bottom: 0;')}>
                  <span style={convertLineStyleData('color:#666666;')}>配送方式</span>
                  <span
                    className="pull-right"
                    style={convertLineStyleData('font-size: 26rpx;color: #666;')}
                  >
                    {orderInfo.take_out_info.deliver_type == 0
                      ? '商家配送'
                      : orderInfo.take_out_info.deliver_type == 3
                        ? '达达配送'
                        : '蜂鸟配送'}
                  </span>
                </div>
              )}
              <div className="order-detail-section" style={convertLineStyleData('border-bottom:none;')}>
                <div
                  style={convertLineStyleData('display:inline-block;width: 130rpx;vertical-align:top;color:#666666;')}
                >
                  配送地址
                </div>
                <div
                  className="address-info-section"
                  style={convertLineStyleData('text-align:right;font-size:26rpx;vertical-align:middle;display:inline-block;width:calc(100% - 130rpx);color:#666;')}
                >
                  <div style={convertLineStyleData('margin-bottom: 12rpx;display:inline-block;')}>
                    {orderInfo.address_info && orderInfo.address_info.name +
                      ' ' +
                      orderInfo.address_info.contact}
                  </div>
                  <div>
                    {orderInfo.address_info && orderInfo.address_info.province.text +
                      orderInfo.address_info.city.text +
                      orderInfo.address_info.district.text +
                      orderInfo.address_info.detailAddress}
                  </div>
                </div>
              </div>
              {transporterInfo &&
                transporterInfo.transport_order_data.status >= 2 && (
                  <div
                    className="order-detail-section"
                    style={convertLineStyleData('margin-bottom: 0;')}
                  >
                    <span style={convertLineStyleData('color:#666666;')}>骑手信息</span>
                    <div
                      className="pull-right"
                      style={convertLineStyleData('font-size: 26rpx;color: #666;')}
                    >
                      <span>
                        {
                          transporterInfo.transport_order_data.transporter_data
                            .transporter_name
                        }
                      </span>
                      <span className="line"></span>
                      <span
                        style={convertLineStyleData('color:#FF7100')}
                        onClick={this.makePhoneCall}
                        data-phone={
                          transporterInfo.transport_order_data.transporter_data
                            .transporter_phone
                        }
                      >
                        联系骑手
                      </span>
                    </div>
                  </div>
                )}
            </div>
            {hasAdditionalInfo && (
              <div
                className="order-detail-section"
                onClick={this.seeAdditionalInfo}
                style={convertLineStyleData('border-top:1px solid #f2f2f2;margin:0 20rpx;padding:26rpx 30rpx;border: none;')}
              >
                补充信息
                <div className="ico-moon icon-rightarrow pull-right"></div>
              </div>
            )}
            {orderInfo.remark && (
              <div
                className="order-detail-section"
                style={convertLineStyleData('border-top:1px solid #f2f2f2;padding:26rpx 30rpx;margin:0 20rpx 18rpx;')}
              >
                <div className="section-title">留言</div>
                <div className="section-content order-remark">
                  {orderInfo.remark}
                </div>
              </div>
            )}
            <div
              className="order-detail-section"
              style={convertLineStyleData('padding:0 30rpx; border-bottom: none;margin:20rpx;margin-bottom: 56rpx;')}
            >
              <div className="deliver_title" style={convertLineStyleData('margin-top:0;')}>
                订单信息
              </div>
              <div className="order-detail-section" style={convertLineStyleData('margin-bottom: 0;')}>
                <span style={convertLineStyleData('color:#666666;')}>下单时间</span>
                <div
                  className="pull-right"
                  style={convertLineStyleData('font-size: 26rpx;color: #666;')}
                >
                  <span>{orderInfo.add_time}</span>
                </div>
              </div>
              <div className="order-detail-section" style={convertLineStyleData('margin-bottom: 0;')}>
                <span style={convertLineStyleData('color:#666666;')}>订单编号</span>
                <div
                  className="pull-right"
                  style={convertLineStyleData('font-size: 26rpx;color: #666;')}
                >
                  <span>{orderInfo.order_id}</span>
                  <span className="line"></span>
                  <span
                    style={convertLineStyleData('color:#FF7100')}
                    onClick={this.copyOrder}
                    data-order={orderInfo.order_id}
                  >
                    复制
                  </span>
                </div>
              </div>
              {orderInfo.remark && (
                <div className="order-detail-section" style={convertLineStyleData('margin-bottom: 0;')}>
                  <span style={convertLineStyleData('color:#666666;')}>订单备注</span>
                  <div
                    className="pull-right"
                    style={convertLineStyleData('font-size: 26rpx;color: #666;')}
                  >
                    <span>{orderInfo.remark}</span>
                  </div>
                </div>
              )}
            </div>
            {isShowInstruction && (
              <div className="instruction-warp">
                <div className="instruction-container">
                  <div>
                    <div className="instruction-container">
                      <div style={convertLineStyleData('padding: 0 27px;wxcs_style_padding: 0 50rpx;')}>
                        <div className="instruction-title">
                          <span>商家拒绝取消订单原因</span>
                        </div>
                        <span
                          className="instruction-item"
                          style={convertLineStyleData('text-align:center;font-size:26rpx;')}
                        >
                          {orderInfo.refund_info.refuse_msg}
                        </span>
                      </div>
                      <span
                        className="instruction-close"
                        onClick={this.hideInstruction}
                      >
                        知道了
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </React.Fragment>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/official-page/takeout-order-detail/TakeoutOrderDetail.jsx